export default __webpack_public_path__ + "static/media/filterIcon.4b97c971.webp";